// Third party
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

// Components
import { Button } from '@capintel/component-lib/button';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  position?: number;
};

export default function ScrollToTop({ position }: Props) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setActive(window.scrollY > (position ?? window.innerHeight));
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [position]);

  const handleScrollUp = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={classNames('scroll-to-top', { active })}>
      <Button variant="primary" appearance="round" icon="arrow-upward" onClick={handleScrollUp} aria-label={formatMessage('Common.ScrollToTop')} />
    </div>
  );
}
